module.exports = __webpack_public_path__ + "img/mono_18.dc6f8999.png";